// extracted by mini-css-extract-plugin
export default {"link":"rL-z","disabled":"sL-z"};